<template>
  <div class="voice-comp voice-search">
    <div class="flex-grow-0 py-2 px-4">
      <div class="voice-comp">
        <button
          id="record"
          v-if="state!='mic'"
          class="btn"
          style="text-align:center;animation: pulse 2s infinite;
outline:none;width: 50px;height: 50px;font-size: 23px;border-radius: 50%;box-shadow: none;background-color:red;color:white;box-shadow: 0 0px 27px 1.5px rgba(0,0,0,0.2);transition: box-shadow 0.2s ease-in-out;cursor: pointer;z-index:2147483002;border:none;"
          @click="toggle()"
        >
          <span v-if="state=='Loading...'" class="fa fa-spinner fa-spin"></span>
          <div class="voice-wave" v-if="state=='Listening...'">
            <div id="preloader_1">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
          <!-- <span v-if="state=='Listening...'"  class="fas fa-stop"></span> -->
        </button>
        <button
          id="record"
          v-if="state=='mic'"
          class="btn"
          style="text-align:center; margin-top:2px;
outline:none;width: 50px;height: 50px;font-size: 23px;border-radius: 50%;box-shadow: none;background-color:red;color:white;box-shadow: 0 0px 27px 1.5px rgba(0,0,0,0.2);transition: box-shadow 0.2s ease-in-out;cursor: pointer;z-index:2147483002;border:none;"
          @click="toggle()"
        >
          <span class="fas fa-microphone"></span>
        </button>
      </div>

      <div class="voice-comp voice-note">
        <span  class="text-muted"> 
          <span v-if="state!='mic'">{{state}}</span>
          <span v-if="state=='mic'">Click to start recording</span>
          &nbsp; &nbsp; &nbsp;
          <span
            @click="activateTypingMood()"
            class="fas fa-keyboard keyboard-mood"
          ></span>
          <a class="lang-bot" @click="switchToAr()" v-if="botLang=='en'">EN</a>
          <a class="lang-bot" @click="switchToEn()" v-if="botLang=='ar'">AR</a>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { startSpeechRecognition } from "@/libs/speech";
const synth = window.speechSynthesis;
import {Mutex} from 'async-mutex';
const mutex = new Mutex();

export default {
  props: ["disconnected", "profileDefaultLang", "lastMsg", "continuous"],
  data() {
    return {
      animate: false,
      isListening: false,
      context: null,
      source: null,
      state: "mic",
      hasErr: false,
      hasUtterance: false,
      isFirstTime:true,
      botLang:'en',
      release:'',
    };
  },
  mounted() {
    this.$on("error", this.onError);
    this.$on("utterance", this.onUtterance);
    this.$on("stopped", this.onStopped);
    this.$on("start", this.onSpeechStart);
    this.$on("end", this.onSpeechEnd);


  },
  watch: {
    lastMsg: async function(audioContent) {
      if (audioContent) {
        this.setDefaultToggle();
        this.release = await mutex.acquire();
        if (audioContent.buffer) {
          this.speakAdvanced(audioContent.buffer);
        } else if (audioContent.text) {
          this.speakDefault(audioContent.text);
        }
      }
    }
  },

  methods: {
    toggle() {
      if (this.isListening === false && this.state === "mic") {
        this.isListening = true;

        startSpeechRecognition(this, {
          language: this.getSpeechLang(),
          continuous: this.continuous,
          isFirstTime:  this.isFirstTime
        });
      } else {
        this.setDefaultToggle();
        this.stopRecognition();
      }
      this.stopSpeech();
      this.hasErr = false;
      this.hasUtterance = false;
    },
    setDefaultToggle() {
      this.state = "mic";
      this.isListening = false;
      this.hasUtterance = false;
    },
    pauseVideo() {
      this.$root.$emit("pauseVideo", this.isListening);
    },
    switchToAr(){
      this.botLang='ar';
    },
    switchToEn(){
     this.botLang='en';
    },
    stopRecognition() {
      let forceStopRecognition = true;
      this.$emit("stoprecognition", forceStopRecognition);
    },
    activateTypingMood() {
      this.$emit("activateTypingMood");
    },
    onUtterance(utterance) {
      this.hasUtterance = true;
      if (utterance) {
        this.$emit("addUtterance", {
          text: utterance,
          format: "voice"
        });
      }
    },
    onStopped() {
      this.animate = false;
    },
    onError(err) {
      this.$emit("hasError", err);
      this.hasErr = true;
      this.setDefaultToggle();
    },
    getSpeechLang() {
      if (this.botLang == "ar") {
        return "ar-SA";
      }
      return "en-US";
    },
    onSpeechStart(state) {
      if (!this.hasErr) {
        this.state = state;
      }
      this.isFirstTime = false;
    },
    onSpeechEnd(state) {
      if (!this.hasErr && this.hasUtterance) {
        this.state = state;
        this.isListening = false;
        this.hasUtterance = false;
      } else {
        this.setDefaultToggle();
        if (this.continuous) {
          this.stopRecognition();
        }
      }
    },
    speakAdvanced(audio) {
      if (this.canSpeak(audio)) {
        // convert audio.data of bytes to ArrayBuffer
        const arrayBuffer = new ArrayBuffer(audio.data.length);
        const bufferView = new Uint8Array(arrayBuffer);
        for (let i = 0; i < audio.data.length; i++) {
          bufferView[i] = audio.data[i];
        }
        this.context = new (window.AudioContext || window.webkitAudioContext)();
        this.context.decodeAudioData(
          arrayBuffer,
          buffer => {
            this.play(buffer);
          },
          error => {
            this.$emit("hasError", error);
          }
        );
      }
    },
    speakDefault(txt) {
      synth.cancel();
      if (synth.speaking) {
        console.error("Still speaking, voice will be queued");
      }
      if (txt) {
        let utterThis = new SpeechSynthesisUtterance(txt);
        utterThis.onend = (event) =>{
          console.log("event :::::::::::::", event);
          this.release();
        };
        utterThis.onerror = (event) =>{
          console.error("SpeechSynthesisUtterance.onerror", event);
          this.release();
        };
        let voices = synth.getVoices();
        let voice = voices.find(
          v => v.lang == "en-GB" && v.name == "Google UK English Female"
        );
        if (voice) {
          utterThis.voice = voice;
        } else {
          console.error("cannot find a voice!");
        }
        utterThis.volume = 1;
        synth.speak(utterThis);
        this.$emit("finishedSpeak", null);
      }
    },
    canSpeak(audio) {
      let validAudio = audio && audio.data && audio.data.length;
      let validAudioContext = window.AudioContext || window.webkitAudioContext;
      return validAudio && validAudioContext;
    },
    async play(buffer) {
      if (this.context.state !== "running") {
        await this.context.resume();
      }
      if (this.source) {
        this.source.stop();
      }
      // Create a source node from the buffer
      this.source = this.context.createBufferSource();
      this.source.buffer = buffer;
      // Connect to the final output node (the speakers)
      this.source.connect(this.context.destination);
      // Play immediately
      this.source.start(0);
      this.source.onended = () => {
          this.release();
      };
      this.$emit("finishedSpeak", null);
    },
    async stopSpeech() {
      this.pauseVideo();
      if (this.source && this.context && this.context.state === "running") {
        this.source.stop();
        await this.context.close();
      } else if (synth && synth.speaking) {
        synth.cancel();
      }
    }
  }
};
</script>

<style>
.voice-comp {
  margin: 0 auto;
  text-align: center;
}

.voice-search {
  border-top: 1px solid rgb(230, 230, 230);
  width: 100%;
  bottom: 0;
}

.pulse-animate {
}

@-webkit-keyframes pulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(204, 169, 44, 0.4);
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(204, 169, 44, 0);
  }

  100% {
    -webkit-box-shadow: 0 0 0 0 rgba(204, 169, 44, 0);
  }
}

@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(204, 169, 44, 0.4);
    box-shadow: 0 0 0 0 rgba(204, 169, 44, 0.4);
  }

  70% {
    -moz-box-shadow: 0 0 0 10px rgba(204, 169, 44, 0);
    box-shadow: 0 0 0 10px rgba(204, 169, 44, 0);
  }

  100% {
    -moz-box-shadow: 0 0 0 0 rgba(204, 169, 44, 0);
    box-shadow: 0 0 0 0 rgba(204, 169, 44, 0);
  }
}

.voice-note {
  margin-top: 6px;
}

.keyboard-mood {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 20px;
  color: #b1c6d0;
  margin-top: -3px;
}

.keyboard-mood:hover {
  transform: scale(1.1);
}

.voice-wave {
  margin: 0 auto;
  margin-top: 16px;
  margin-right: 28px;
}

#preloader_1 {
  position: relative;
}

#preloader_1 span {
  display: block;
  bottom: 0px;
  width: 7px;
  height: 5px;
  background: #34324b;
  position: absolute;
  animation: preloader_1 1.5s infinite ease-in-out;
}

#preloader_1 span:nth-child(2) {
  left: 11px;
  animation-delay: 0.2s;
}

#preloader_1 span:nth-child(3) {
  left: 22px;
  animation-delay: 0.4s;
}

#preloader_1 span:nth-child(4) {
  left: 33px;
  animation-delay: 0.6s;
}

#preloader_1 span:nth-child(5) {
  left: 44px;
  animation-delay: 0.8s;
}

@keyframes preloader_1 {
  0% {
    height: 10px;
    transform: translateY(0px);
    background: #fff;
  }

  25% {
    height: 10px;
    transform: translateY(15px);
    background: #fff;
  }

  50% {
    height: 20px;
    transform: translateY(0px);
    background: #fff;
  }

  100% {
    height: 10px;
    transform: translateY(0px);
    background: #fff;
  }
}
.lang-bot{
  font-size: 15px;
  padding-left: 7px;
  text-decoration:underline !important;
  cursor: pointer;
}
</style>
